import { render, staticRenderFns } from "./AdDailyAccountReport.vue?vue&type=template&id=992d3b68&scoped=true"
import script from "./AdDailyAccountReport.vue?vue&type=script&lang=js"
export * from "./AdDailyAccountReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992d3b68",
  null
  
)

export default component.exports